<template>
    <div v-if="item">
        <v-layout row wrap>
             <v-flex md8 sm12 xs12>
                 <div v-if="item.ManyAppInmuebleImage.length == 1" style="text-align:center;">
                     <img
                       :src="item.ManyAppInmuebleImage[0].description_source"
                       style="max-width:100%; max-height:500px; object-fit:contain; background:#D9D9D9;"
                       alt="Imagen inmueble"
                     />
                 </div>
                 <v-carousel v-if="item.ManyAppInmuebleImage.length > 1" icon="stop">
                  <v-carousel-item v-for="(img,i) in item.ManyAppInmuebleImage" :key="i">
                    <img
                      :src="img.description_source"
                      style="width:100%; height:500px; object-fit:contain; background:#D9D9D9;"
                      :alt="'Imagen inmueble ' + (i+1)"
                    />
                  </v-carousel-item>
                </v-carousel>

                <p class="title grey--text text--darken-1 mt-5" v-html="item.desarrollo"></p>

             </v-flex>
             <v-flex md4 sm12 xs12 pl-2>
                 <h2 class="display-2 text--darken-1">{{ item.description }}</h2>

                <v-chip label class="lime accent-2 ">{{ item.AppTipoOperacion.description }}</v-chip>
                <v-chip label v-if="item.AppTipoMoneda && item.precio"><strong> {{ item.AppTipoMoneda.codigo }} {{ item.precio.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") }} </strong></v-chip>

                <v-chip label >{{ item.AppTipoPropiedad.singular }} </v-chip>

                <v-chip v-if="item.cantidad_dormitorios > 0" label outline class="grey lighten-4">
                  {{ item.cantidad_dormitorios }}
                    <template v-if="item.cantidad_dormitorios == 1">Dormitorio</template>
                  <template v-if="item.cantidad_dormitorios > 1">Dormitorios</template>
                </v-chip>

                <v-chip v-if="item.cantidad_banios > 0" label outline class="grey lighten-4">
                   {{ item.cantidad_banios}}
                   <template v-if="item.cantidad_banios == 1">Baño</template>
                   <template v-if="item.cantidad_banios > 1">Baños</template>
                </v-chip>

                <v-chip v-if="item.cantidad_cocheras > 0" label outline class="grey lighten-4">

                   {{ item.cantidad_cocheras}}
                   <template v-if="item.cantidad_cocheras == 1">Cochera</template>
                   <template v-if="item.cantidad_cocheras > 1">Cocheras</template>
                </v-chip>

                <v-divider></v-divider>
                <app-inmobiliaria-widget 
                    :item="item.Sucursal.Empresa" 
                    v-bind="item.AppInmuebleEstado.id != 1 ? {ribbon: item.AppInmuebleEstado.description} : {}"
                    >
                </app-inmobiliaria-widget>

                    <v-divider></v-divider>
                <div class="overview">

                 </div>


             </v-flex>
        </v-layout>

        <v-layout row wrap>
             <v-flex xs12 >
                        <div class="divider thin"></div>

                        <v-layout row wrap v-if="item.ManyAppTipoServicio.length">
                          <v-flex xs12>
                              <h4 class="display-1 mt-4">Servicios</h4>
                          </v-flex>
                          <v-flex  xs12 md3 v-for="(r,i) in item.ManyAppTipoServicio" :key="i">
                              <v-chip label class="lime lighten-4">
                                  <v-icon left dark>check_circle</v-icon> {{ r.description }}
                                </v-chip>
                          </v-flex>
                        </v-layout>

                        <v-layout row wrap v-if="item.ManyAppTipoInstalacion.length">
                          <v-flex xs12>
                              <h4 class="display-1 mt-4">Instalaciones</h4>
                          </v-flex>
                          <v-flex  xs12 md3 v-for="(r,i) in item.ManyAppTipoInstalacion" :key="i">
                              <v-chip label class="lime lighten-4">
                                  <v-icon left dark>check_circle</v-icon> {{ r.description }}
                                </v-chip>

                          </v-flex>
                        </v-layout>

                        <v-layout row wrap v-if="item.ManyAppTipoAmbiente.length">
                          <v-flex xs12>
                              <h4 class="display-1 mt-4">Ambientes</h4>
                          </v-flex>
                          <v-flex xs12 md3 v-for="(r,i) in item.ManyAppTipoAmbiente" :key="i">
                              <v-chip label class="lime lighten-4">
                                  <v-icon left dark>check_circle</v-icon> {{ r.description }}
                                </v-chip>
                          </v-flex>
                        </v-layout>


                    </v-flex>
                </v-layout>


    </div>
</template>

<script>
  import AppInmobiliariaWidget from '@/components/AppInmobiliariaWidget'
  import axios from 'axios';
  export default {
    data () {
      return {
        item: '',
        drawer: false,
        seoPage: {
          title: 'Propiedad',
          complement: '',
          ogTitle: '',
          ogImage: ''
        }
      }
    },
    head: {
        title: function () {
          return {
            inner: this.seoPage.title,
            //separator: '-',
            complement: this.seoPage.complement
          }
        },
        meta: function () {
              return [
              // Twitter
              { name: 'twitter:title', content:this.seoPage.title },
              { name: 'twitter:description', content: ''},

              // Facebook / Open Graph
              { property: 'og:title', content: this.seoPage.ogTitle },
              { property: 'og:type', content: 'website' },
              { property: 'og:image', content: this.seoPage.ogImage },


            ]
        }
    },
    watch: {
      // call again the method if the route changes
      '$route': 'fetchData'
    },
    mounted: function () {
      this.fetchData();
    },
    components: {
        AppInmobiliariaWidget
    },
    computed: {
        empresa () {
          return this.$store.getters.brand
        },
        empresaCargada () {
          return this.$store.getters.brandReady
        }
      },
    methods: {
    fetchData: function() {
     // console.log('fetch inmueble');
        axios.get(this.$apiUrl + 'app_inmueble/item?id=' + this.$route.params.id).then(response => {
            //console.log(response);
            this.item = response.data.item
            this.seoPage.title = response.data.item.description
            this.seoPage.ogTitle = response.data.item.description + ' ' +response.data.item.AppTipoOperacion.description + ' ' + response.data.item.AppTipoPropiedad.singular
            this.seoPage.complement = response.data.item.AppTipoOperacion.description + ' ' + response.data.item.AppTipoPropiedad.singular + ' | ' + this.empresa.description
            if(response.data.item.ManyAppInmuebleImage.length > 0){
                this.seoPage.ogImage = response.data.item.ManyAppInmuebleImage[0].description_source
            }
            this.$emit('updateHead')
        }).catch(e => {
            //this.$router.go('/404')
      	});		
  },

}
 }
</script>

<style>
ul {
  margin-left:20px
}
</style>


// WEBPACK FOOTER //
// AppInmueble.vue?63ea8038